module.exports = __webpack_public_path__ + "static/media/cookbook-title-mobile.8e35b5e9.svg";